<pmv-main-content>
    <pmv-main-content-header title="Dados Adicionais" [subtitle]="subtitle">
        <pmv-loading [isLoading]="loading"></pmv-loading>
    </pmv-main-content-header>
</pmv-main-content>

<pmv-main-content-body>




    <form #form="ngForm" validateOnSubmit (submit)="onSubmit(form)">
        <div class="row" style="margin-bottom: 25px;;">
            <div class="col-xs-12">
                <h2>Informações do Edital/Convocação</h2>
                <span style="display: block;color:#2D699F;">{{editalAnoPss}}</span><br>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12" style="margin-bottom: 10px;">
                <pmv-fieldset header="Dados Pessoais" class="filtros-fieldset">

                    <div class="col-md-12 col-xs-12">
                        <pmv-input-text [(ngModel)]="pessoaForm.nomePai" maxlength="70" name="nomePai"
                            [disabled]="pessoaBD.nomePai != null" label="Nome do Pai*">
                        </pmv-input-text>
                    </div>
                    <div class="col-md-3 col-xs-12">
                        <pmv-dropdown [(ngModel)]="pessoaForm.codigoGrupoSanguineo" label="Grupo Sanguineo*"
                            [disabled]="pessoaBD.codigoGrupoSanguineo != null" name="grupoSanguineoValue"
                            [options]="grupoSanguineoOptions" optionLabelField="descricao" optionValueField="id"
                            defaultOption=" ">
                        </pmv-dropdown>
                    </div>
                    <div class="col-md-3 col-xs-12">
                        <pmv-dropdown [(ngModel)]="pessoaForm.codigoFatorRH" label="Fator RH*" name="fatorRHValue"
                            [options]="fatorRHOptions" optionLabelField="descricao" optionValueField="id"
                            defaultOption=" " [disabled]="pessoaBD.codigoFatorRH != null">
                        </pmv-dropdown>
                    </div>
                    <div class="col-md-3 col-xs-12">
                        <pmv-dropdown [(ngModel)]="pessoaForm.codigoPaisNascimento" label="País de Nascimento*"
                            name="codigoPaisNascimento" [options]="paisDeNascimentoOptions" optionLabelField="descricao"
                            optionValueField="id" defaultOption=" " [disabled]="pessoaBD.codigoPaisNascimento != null">
                        </pmv-dropdown>
                    </div>
                    <div class="col-md-3 col-xs-12">
                        <pmv-dropdown [(ngModel)]="pessoaForm.codigoTipoDeficiencia" label="Deficiência*"
                            name="codigoTipoDeficiencia" [options]="tipoDeficienciaOptions" optionLabelField="descricao"
                            optionValueField="id" defaultOption=" "
                            [disabled]="pessoaForm.codigoTipoDeficiencia >= 0">
                        </pmv-dropdown>
                    </div>
                    <div class="col-md-3 col-xs-12">
                        <pmv-dropdown [(ngModel)]="pessoaForm.possuiPrevidenciaComplementar"
                            label="Possui Previdência Complementar?*" name="possuiPrevidenciaComplementar"
                            [options]="possuiPrevidenciaComplementarOptions" optionLabelField="descricao"
                            optionValueField="id" defaultOption=" "
                            [disabled]="pessoaBD.possuiPrevidenciaComplementar != null">
                        </pmv-dropdown>
                    </div>
                </pmv-fieldset>

                <pmv-fieldset header="Titulo de Eleitor" class="filtros-fieldset">
                    <div class="col-md-3 col-xs-12">
                        <pmv-input-text [(ngModel)]="pessoaForm.documentos.titulo" maxlength="13" name="titulo"
                            label="Número do Título*" [disabled]="pessoaBD.documentos.titulo != null">
                        </pmv-input-text>
                    </div>
                    <div class="col-md-3 col-xs-12">
                        <pmv-input-text [(ngModel)]="pessoaForm.documentos.zonaTitulo" maxlength="5" name="zonaTitulo"
                            label="Zona*" [disabled]="pessoaBD.documentos.zonaTitulo != null">
                        </pmv-input-text>
                    </div>
                    <div class="col-md-3 col-xs-12">
                        <pmv-input-text [(ngModel)]="pessoaForm.documentos.secaoTitulo" maxlength="5" name="secao"
                            label="Seção*" [disabled]="pessoaBD.documentos.secaoTitulo != null">
                        </pmv-input-text>
                    </div>
                    <div class="col-md-3 col-xs-12">
                        <pmv-datepicker [(ngModel)]="pessoaForm.documentos.emissaoTitulo" name="emissaoTitulo"
                            label="Data emissão*" [showTime]="false"
                            [disabled]="pessoaBD.documentos.emissaoTitulo != null">
                        </pmv-datepicker>
                    </div>
                    <div class="col-md-3 col-xs-12">
                        <label>UF*</label>
                        <div class="ui-inputgroup">
                            <div class="col-xs-12" style="padding-right: 0px; padding-left: 0px;">
                                <pmv-dropdown [(ngModel)]="pessoaForm.documentos.codigoUfTitulo"
                                    name="codigoUfTituloValue" [options]="ufOptions" optionLabelField="descricao"
                                    optionValueField="id" defaultOption=" "
                                    [disabled]="pessoaBD.documentos.codigoUfTitulo != null">
                                </pmv-dropdown>
                            </div>
                            <button type="button" (click)="CarregarCidadesTitulo()" class="btn btn-default"
                            [disabled]="pessoaBD.documentos.codigoUfTitulo != null"><i class="fa fa-search"
                                    aria-hidden="true"></i></button>
                        </div>


                    </div>
                    <div class="col-md-3 col-xs-12">
                        <pmv-dropdown [(ngModel)]="pessoaForm.documentos.codigoCidadeTitulo" label="Cidade do título*"
                            name="codigoCidadeTituloValue" [options]="cidadeTituloOptions" optionLabelField="descricao"
                            optionValueField="id" defaultOption=" "
                            [disabled]="habilitarCidadeTituloForm">
                        </pmv-dropdown>
                    </div>
                </pmv-fieldset>

                <pmv-fieldset header="Carteira de Trabalho" class="filtros-fieldset">
                    <div class="col-md-3 col-xs-12">
                        <pmv-input-text [(ngModel)]="pessoaForm.documentos.ctpsNumero" maxlength="10" name="ctpsNumero"
                            label="Número*" [disabled]="pessoaBD.documentos.ctpsNumero != null">
                        </pmv-input-text>
                    </div>
                    <div class="col-md-3 col-xs-12">
                        <pmv-input-text [(ngModel)]="pessoaForm.documentos.ctpsSerie" maxlength="10" name="ctpsSerie"
                            label="Série*" [disabled]="pessoaBD.documentos.ctpsSerie != null">
                        </pmv-input-text>
                    </div>
                    <div class="col-md-3 col-xs-12">
                        <pmv-dropdown [(ngModel)]="pessoaForm.documentos.ctpsUf" label="UF*" name="ctpsUfValue"
                            [options]="ufOptions" optionLabelField="descricao" optionValueField="id" defaultOption=" "
                            [disabled]="pessoaBD.documentos.ctpsUf != null">
                        </pmv-dropdown>
                    </div>
                    <div class="col-md-3 col-xs-12">
                        <pmv-datepicker [(ngModel)]="pessoaForm.documentos.ctpsEmissao" name="ctpsEmissao"
                            label="Data emissão*" [showTime]="false"
                            [disabled]="pessoaBD.documentos.ctpsEmissao != null">
                        </pmv-datepicker>
                    </div>
                </pmv-fieldset>

                <pmv-fieldset header="PIS/PASEP" class="filtros-fieldset">
                    <div class="col-md-3 col-xs-12">
                        <pmv-input-text [(ngModel)]="pessoaForm.documentos.pisNumero" maxlength="12" name="pisNumero"
                            label="Número*" [disabled]="pessoaBD.documentos.pisNumero != null">
                        </pmv-input-text>
                    </div>
                    <div class="col-md-3 col-xs-12">
                        <pmv-datepicker [(ngModel)]="pessoaForm.documentos.pisInscricao" name="pisInscricao"
                            label="Inscrição*" [showTime]="false" [disabled]="pessoaBD.documentos.pisInscricao != null">
                        </pmv-datepicker>
                    </div>
                </pmv-fieldset>

                <pmv-fieldset header="Habilitação" class="filtros-fieldset">
                    <div class="col-md-4 col-xs-12">
                        <pmv-input-text [(ngModel)]="pessoaForm.documentos.cnhNumero" maxlength="11" name="cnhNumero"
                            label="Número" [disabled]="pessoaBD.documentos.cnhNumero != null">
                        </pmv-input-text>
                    </div>
                    <div class="col-md-3 col-xs-12">
                        <pmv-input-text [(ngModel)]="pessoaForm.documentos.cnhOrgaoEmissor" maxlength="20"
                            name="cnhOrgaoEmissor" label="Órgão emissor"
                            [disabled]="pessoaBD.documentos.cnhOrgaoEmissor != null">
                        </pmv-input-text>
                    </div>
                    <div class="col-md-2 col-xs-12">
                        <pmv-dropdown [(ngModel)]="pessoaForm.documentos.cnhUf" label="UF" name="cnhUfValue"
                            [options]="ufOptions" optionLabelField="descricao" optionValueField="id" defaultOption=" "
                            [disabled]="pessoaBD.documentos.cnhUf != null">
                        </pmv-dropdown>
                    </div>
                    <div class="col-md-3 col-xs-12">
                        <pmv-datepicker [(ngModel)]="pessoaForm.documentos.cnhEmissao" name="cnhEmissao"
                            label="Data emissão" [showTime]="false" [disabled]="pessoaBD.documentos.cnhEmissao != null">
                        </pmv-datepicker>
                    </div>
                    <div class="col-md-2 col-xs-12">
                        <pmv-dropdown [(ngModel)]="pessoaForm.documentos.cnhCategoria" label="Categoria"
                            name="cnhCategoriaValue" [options]="cnhCategoriafOptions" optionLabelField="descricao"
                            optionValueField="id" defaultOption=" "
                            [disabled]="pessoaBD.documentos.cnhCategoria != null">
                        </pmv-dropdown>
                    </div>
                    <div class="col-md-3 col-xs-12">
                        <pmv-datepicker [(ngModel)]="pessoaForm.documentos.cnhPrimeiraEmissao" name="cnhPrimeiraEmissao"
                            label="Data da 1° Habilitação" [showTime]="false"
                            [disabled]="pessoaBD.documentos.cnhPrimeiraEmissao != null">
                        </pmv-datepicker>
                    </div>
                    <div class="col-md-3 col-xs-12">
                        <pmv-datepicker [(ngModel)]="pessoaForm.documentos.cnhValidade" name="cnhValidade"
                            label="Data validade" [showTime]="false"
                            [disabled]="pessoaBD.documentos.cnhValidade != null">
                        </pmv-datepicker>
                    </div>
                </pmv-fieldset>


                <pmv-fieldset header="Reservista/C.S.M." class="filtros-fieldset">
                    <div class="col-md-4 col-xs-12">
                        <pmv-input-text [(ngModel)]="pessoaForm.documentos.reservistaNumero" maxlength="15"
                            name="reservistaNumero" label="Número"
                            [disabled]="pessoaBD.documentos.reservistaNumero != null">
                        </pmv-input-text>
                    </div>
                    <div class="col-md-3 col-xs-12">
                        <pmv-input-text [(ngModel)]="pessoaForm.documentos.reservistaSerie" maxlength="10"
                            name="reservistaSerie" label="Série"
                            [disabled]="pessoaBD.documentos.reservistaSerie != null">
                        </pmv-input-text>
                    </div>
                    <div class="col-md-2 col-xs-12">
                        <pmv-dropdown [(ngModel)]="pessoaForm.documentos.reservistaUf" label="UF" name="reservistaUf"
                            [options]="ufOptions" optionLabelField="descricao" optionValueField="id" defaultOption=" "
                            [disabled]="pessoaBD.documentos.reservistaUf != null">
                        </pmv-dropdown>
                    </div>
                    <div class="col-md-3 col-xs-12">
                        <pmv-datepicker [(ngModel)]="pessoaForm.documentos.reservistaEmissao" name="reservistaEmissao"
                            label="Data emissão" [showTime]="false"
                            [disabled]="pessoaBD.documentos.reservistaEmissao != null">
                        </pmv-datepicker>
                    </div>
                    <div class="col-md-3 col-xs-12">
                        <pmv-input-text [(ngModel)]="pessoaForm.documentos.reservistaOrgaoEmissor" maxlength="20"
                            name="reservistaOrgaoEmissor" label="Órgão emissor"
                            [disabled]="pessoaBD.documentos.reservistaOrgaoEmissor != null">
                        </pmv-input-text>
                    </div>
                    <div class="col-md-2 col-xs-12">
                        <pmv-dropdown [(ngModel)]="pessoaForm.documentos.reservistaCategoria" label="Categoria"
                            name="reservistaCategoria" [options]="reservistaCategoriaOptions"
                            optionLabelField="descricao" optionValueField="id" defaultOption=" "
                            [disabled]="pessoaBD.documentos.reservistaCategoria != null">
                        </pmv-dropdown>
                    </div>
                    <div class="col-md-2 col-xs-12">
                        <pmv-dropdown [(ngModel)]="pessoaForm.documentos.reservistaForca" label="Força Armada"
                            name="reservistaForca" [options]="reservistaForcaOptions" optionLabelField="descricao"
                            optionValueField="id" defaultOption=" "
                            [disabled]="pessoaBD.documentos.reservistaForca != null">
                        </pmv-dropdown>
                    </div>
                </pmv-fieldset>

                <pmv-fieldset header="Conselho Regional" class="filtros-fieldset">
                    <div class="col-md-4 col-xs-12">
                        <pmv-input-text [(ngModel)]="pessoaForm.documentos.conselhoRegionalNumero" maxlength="12"
                            name="conselhoRegionalNumero" label="Número"
                            [disabled]="pessoaBD.documentos.conselhoRegionalNumero != null">
                        </pmv-input-text>
                    </div>
                    <div class="col-md-3 col-xs-12">
                        <pmv-input-text [(ngModel)]="pessoaForm.documentos.conselhoRegionalOrgao" maxlength="70"
                            name="conselhoRegionalOrgao" label="Órgão Clasista"
                            [disabled]="pessoaBD.documentos.conselhoRegionalOrgao != null">
                        </pmv-input-text>
                    </div>
                    <div class="col-md-2 col-xs-12">
                        <pmv-dropdown [(ngModel)]="pessoaForm.documentos.conselhoRegionalUf" label="UF"
                            name="conselhoRegionalUf" [options]="ufOptions" optionLabelField="descricao"
                            optionValueField="id" defaultOption=" "
                            [disabled]="pessoaBD.documentos.conselhoRegionalUf != null">
                        </pmv-dropdown>
                    </div>
                    <div class="col-md-3 col-xs-12">
                        <pmv-datepicker [(ngModel)]="pessoaForm.documentos.conselhoRegionalEmissao"
                            name="conselhoRegionalEmissao" label="Data emissão" [showTime]="false"
                            [disabled]="pessoaBD.documentos.conselhoRegionalEmissao != null">
                        </pmv-datepicker>
                    </div>
                    <div class="col-md-3 col-xs-12">
                        <pmv-input-text [(ngModel)]="pessoaForm.documentos.conselhoRegionalRegiao" maxlength="20"
                            name="conselhoRegionalRegiao" label="Região"
                            [disabled]="pessoaBD.documentos.conselhoRegionalRegiao != null">
                        </pmv-input-text>
                    </div>
                    <div class="col-md-3 col-xs-12">
                        <pmv-input-text [(ngModel)]="pessoaForm.documentos.conselhoRegionalProtocolo" maxlength="11"
                            name="conselhoRegionalProtocolo" label="Protocolo"
                            [disabled]="pessoaBD.documentos.conselhoRegionalProtocolo != null">
                        </pmv-input-text>
                    </div>
                    <div class="col-md-3 col-xs-12">
                        <pmv-datepicker [(ngModel)]="pessoaForm.documentos.conselhoRegionalValidade"
                            name="conselhoRegionalValidade" label="Validade" [showTime]="false"
                            [disabled]="pessoaBD.documentos.conselhoRegionalValidade != null">
                        </pmv-datepicker>
                    </div>
                </pmv-fieldset>
            </div>

            <div class="col-md-12" style="text-align: right; padding: 5px 22px;">
                <button type="submit" class="btn btn-primary">Salvar</button>
                <button type="button" class="btn btn-warning" (click)="voltar()">Cancelar</button>
            </div>
        </div>

    </form>

</pmv-main-content-body>


// WEBPACK FOOTER //
// ./src/app/pages/candidato-convocado/dadosAdicionais/dados-adicionais.component.html